import { getField, updateField } from "vuex-map-fields";
import { createProfile,
        updateProfile, 
        filesUpload, 
        saveEligibilityChecked, 
        getCardForUserId, 
        submitUserApplication,
        saveProfileField } from "../../feathers";

const state = {
    newProfile: {
        name: "",
        currentOccupation: "",
        countryOfResidence: "",
        countryOfOrigin: "",
        dateOfBirth: "",
        phoneNumber: "",
        photoFileId: "",
        gender: ""
    },
    profile: {
        _id: "",
        name: "",
        gender: "",
        currentOccupation: "",
        countryOfResidence: "",
        countryOfOrigin: "",
        dateOfBirth: "",
        phoneNumber: "",
        photoFileId: "",
        photo: {
            originalName: "",
            url: ""
        },
        groupConversationId: "",
        background: "",
        degreeFileId: "",
        degree: {
            originalName: ""
        },
        degreeTranscriptFileId: "",   
        degreeTranscript: {
            originalName: ""
        },     
        hasMasters: true,
        mastersFileId: "",
        masters: {
            originalName: ""
        },
        mastersTranscriptFileId: "",   
        mastersTranscript: {
            originalName: ""
        }, 
        hasPhd: false,
        phdFileId: "",
        phd: {
            originalName: ""
        },  
        phdTranscriptFileId: "",   
        phdTranscript: {
            originalName: ""
        },               
        cvFileId: "",
        cv: {
            originalName: ""
        },
        motivationLetterText: "",
        motivationLetterFileId: "",
        motivationLetter: {
            originalName: ""
        },
        reference1FileId: "",
        reference1ProvidedBy: "",
        reference1Position: "",
        reference2FileId: "",
        reference2ProvidedBy: "",
        reference2Position: "",
        reference3FileId: "",
        reference3ProvidedBy: "",
        reference3Position: "", 
        isPassportValid:true,
        passportFileId: "",
        passport: {
            originalName: ""
        },
        isComplete: false
    }
};

const mutations = {
    updateField
};

const getters = {
    getField
};

const actions = {

    async getProfile({ commit, dispatch }, userId) {
        const { data } = await getCardForUserId(userId);

        if (data && data.length > 0) {
            await dispatch("profile/setProfile", data[0], { root: true });
            return data[0];
        }

        return null;
    },

    async currentProfile({ state }){
        return await state.profile;
    },

    async createProfile(_, profile) {
        const data = await createProfile(profile);
        return data;
    },

    async updateProfile(_, profile){
        const data = await updateProfile(profile);
        return data;
    },

    async uploadProfilePicture(_, fileData) {
        const formData = new FormData();

        // Pass the image file name as the third parameter if necessary.
        formData.append('file', fileData/*, 'example.png' */);
        return await filesUpload(formData);
    },

    async saveEligibilityChecked(_, applicantId) {
        return await saveEligibilityChecked(applicantId);
    },

    async uploadFile(_, file){
        const result = await filesUpload(file);
        if (result && result.length){
            return result[0];
        }

        return null;
    },

    async updateProfileField({ state }, { fieldName, fieldValue }){
        return await saveProfileField(state.profile._id, fieldName, fieldValue);
    },


    async removeProfileField(fieldName){

        return await saveProfileField(state.profile._id, fieldName, null);
    },

    setProfile({ commit }, profile){        
        const mergedProfile = {...state.profile, ...profile};

        commit("updateField", {
            path: "profile",
            value: mergedProfile
        });        
    },

    async submitApplication({ commit, state }){

        const data = await submitUserApplication(state.profile._id);

        commit("updateField", {
            path: "profile.isComplete",
            value: true
        });      
                 
        return data;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};